var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"pt-5 pb-5 justify-content-center"},[_c('b-col',[_c('ListFiltersComponent',{attrs:{"filtersToDisplay":_vm.filtersToDisplay},on:{"changeFilterEvent":_vm.handleChangeFilterEvent}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }